import { ChevronDownIcon, ChevronRightIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    FormControl,
    Icon,
    Input,
    InputGroup,
    InputRightAddon,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    Select,
    Spinner,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import AppTableWithPagination from 'components/AppTableWithPagination';
import DeleteConfirmationModal from 'components/genericForms/DeleteConfirmationModal';
import currencySymbolMap from 'currency-symbol-map';
import { useFormik } from 'formik';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { GiStarShuriken } from "react-icons/gi";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { MdDelete, MdEdit } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDeleteCampaignMutation, useDuplicateCampaignMutation, useGetAdspressoAllCampaignListQuery, useGetAdspressoAllCampaignsQuery, useUpdateCampaignMutation, useUpdateCampaignStatusMutation, useUpdateEntriesCampaignMutation, useGetAllcampaignsInsightsQuery } from 'store/campaigns/campaignsApi';
import { selectAfter, selectPresentPage, selectCampaignlistLoading, selectCampaignsForInsights, selectCurrentPage, selectSelectedCampaignId, setCampaignDataLoading, setCampaignListLoading, setPresentPage, setSelectedCampaignId } from 'store/campaigns/campaignsSlice';
import * as Yup from 'yup';
import { bidStrategiesForLeads, bidStrategiesForSales, budgetOptions } from '../../utils/campaignOptions';

function AllCampaignsTable({ startDate, endDate, datePreset, setSelectedTab, onRefresh, onRefreshComplete }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const background = useColorModeValue('gray.50', 'gray.800');
    const location = useLocation();
    const isMounted = useRef(false);
    const selectedCampaignId = useSelector(selectSelectedCampaignId);
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const isCampaignsListLoading = useSelector(selectCampaignlistLoading);
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isDuplicateModalOpen, onOpen: onDuplicateModalOpen, onClose: onDuplicateModalClose } = useDisclosure();
    const { isOpen: isBidModalOpen, onOpen: onBidModalOpen, onClose: onBidModalClose } = useDisclosure();
    const [isCreateFormVisible, setIsCreateFormVisible] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const presentPage = useSelector(selectPresentPage);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [campaignInsights, setCampaignInsights] = useState([]);
    const [campaignsListWithInsights, setCampaignsListWithInsights] = useState([]);
    const [switchStates, setSwitchStates] = useState({});
    const [isLoadingAccountChange, setIsLoadingAccountChange] = useState(false);
    const [copyCount, setCopyCount] = useState(1);
    const [adsetBidAmounts, setAdsetBidAmounts] = useState({});
    const [isLoadingCampaignsListWithInsights, setIsLoadingCampaignsListWithInsights] = useState(true);
    const currencyCode = selectedCampaign?.currency;
    const currencySymbol = currencySymbolMap(currencyCode);

    const { data: allCampaignsIds, isFetching: isAllCampaignIdsFetching, refetch: refetchAllCampaignsIds, isLoading: isAllCampaignIdsLoading, error: AllcampaignsIdsError } = useGetAdspressoAllCampaignsQuery({ currentPage: presentPage }, {});

    const { data: allCampaignsList, isFetching: isAllCampaignListFetching, refetch: refetchAllCampaignsList, isLoading: isAllCampaignListLoading, error: AllcampaignslistError } = useGetAdspressoAllCampaignListQuery(
        {
            ids: allCampaignsIds?.data || [],
        },
        {
            skip: !allCampaignsIds?.data || allCampaignsIds?.data?.length === 0 || isAllCampaignIdsLoading || isAllCampaignIdsFetching,
        },
    );

    const { data: campaignsInsights, isFetching: isCampaignInsightsListFetcing, refetch: refetchCampaignsInsights, isLoading: isCampaignInsightsLoading, error: campaignsInsightsError } = useGetAllcampaignsInsightsQuery(
        {
            searchValue,
            date_preset: datePreset,
            campaigns: campaignInsights?.length > 0 ? campaignInsights : [],
            ...(datePreset ? {} : { start_date: startDate, end_date: endDate }), // Conditionally add startDate and endDate
        },
        { skip: !campaignInsights?.length === 0 || isAllCampaignListFetching || isAllCampaignIdsFetching, }
    );

    const [updateCampaign, { isLoading: isCampaignUpdating }] = useUpdateCampaignMutation({});
    const [updateEntriesCampaign, { isLoading: isCampaignEntriesUpdating }] = useUpdateEntriesCampaignMutation({});
    const [updateCampaignStatus] = useUpdateCampaignStatusMutation({});
    const [deleteCampaign] = useDeleteCampaignMutation();
    const [duplicateCampaign, { isLoading: isCampaignDuplicating }] = useDuplicateCampaignMutation();

    useEffect(() => {
        if (isCampaignsListLoading) {
            dispatch(setSelectedCampaignId(null));
            localStorage.removeItem("cachedCampaign");
            if (!selectedCampaignId) {
                refetchAllCampaignsIds();
                refetchAllCampaignsList();
                dispatch(setCampaignListLoading(false));
            }
        }
    }, [isCampaignsListLoading, selectedCampaignId]);

    useEffect(() => {
        isMounted.current = true;
        return () => isMounted.current = false;
    }, []);

    useEffect(() => {
        if (onRefresh) {
            refetchAllCampaignsIds();
            refetchAllCampaignsList();
            refetchCampaignsInsights();
            onRefreshComplete();
        }
    }, [onRefresh]);

    useEffect(() => {
        if (allCampaignsList) {
            const initialSwitchStates = {};
            allCampaignsList.forEach(campaign => {
                initialSwitchStates[campaign?.campaign_id] = campaign?.status;
            });
            setSwitchStates(initialSwitchStates);

            const formattedCampaigns = allCampaignsList.reduce((acc, campaign) => {

                const promotedObject = campaign?.adsets?.data?.[0]?.promoted_object;
                const customEventType = promotedObject?.custom_event_type;
                const accountId = campaign?.account_id;

                // Only add campaigns to the list if custom_event_type is present
                if (campaign?.campaign_id) {
                    acc.push({
                        campaign_id: campaign?.campaign_id,
                        promoted_object: promotedObject,
                        account_id: accountId,
                        destination_type: campaign?.adsets?.[0]?.destination_type,
                        optimization_goal: campaign?.adsets?.[0]?.optimization_goal
                    });
                } else {
                    acc.push({
                        campaign_id: campaign?.campaign_id,
                        account_id: accountId,
                        destination_type: campaign?.adsets?.[0]?.destination_type,
                        optimization_goal: campaign?.adsets?.[0]?.optimization_goal
                    });
                }
                return acc;
            }, []);
            setCampaignInsights(formattedCampaigns);
        }
    }, [allCampaignsIds, allCampaignsList]);

    useEffect(() => {
        if (allCampaignsList || campaignsInsights) {
            const campaignsWithInsights = allCampaignsList?.map(campaign => {
                const insightData = campaignsInsights?.find(insight => insight?.campaign_id === campaign?.campaign_id);

                return {
                    ...campaign,
                    insight: insightData?.insights || {},
                };
            });

            setCampaignsListWithInsights(campaignsWithInsights);

            setTimeout(() => {
                setIsLoadingCampaignsListWithInsights(false);
            }, 100);
        }
    }, [allCampaignsList, campaignsInsights]);

    useEffect(() => {
        if (allCampaignsList?.data || campaignsInsights) {
            setIsLoadingAccountChange(false);
        }
    }, [allCampaignsList, campaignsInsights])

    useEffect(() => {
        if (selectedCampaign) {
            formik.setValues({
                name: selectedCampaign?.name,
                objective: selectedCampaign?.objective,
                isAdvantageCampaignEnabled: selectedCampaign?.bid_strategy ? true : false,
                isAdScheduled: selectedCampaign?.pacing_type && selectedCampaign?.pacing_type.includes("day_parting") ? true : false,
                budget: selectedCampaign?.daily_budget ? 'daily_budget' : 'lifetime_budget',
                bid_strategy: selectedCampaign?.bid_strategy ? selectedCampaign?.bid_strategy : 'LOWEST_COST_WITHOUT_CAP',
                daily_budget: selectedCampaign?.daily_budget ? Number(selectedCampaign?.daily_budget) / 100 : 800,
                lifetime_budget: selectedCampaign?.lifetime_budget ? Number(selectedCampaign?.lifetime_budget) / 100 : 14000,
            });

            const initialBids = {};
            selectedCampaign?.adsets?.data?.forEach(adSet => {
                initialBids[adSet?.id] = 5;
            });
            setAdsetBidAmounts(initialBids);

        }
    }, [selectedCampaign]);

    const formik = useFormik({
        initialValues: {
            name: '',
            objective: '',
            isAdvantageCampaignEnabled: false,
            isAdScheduled: false,
            budget: 'daily_budget',
            bid_strategy: 'LOWEST_COST_WITHOUT_CAP',
            daily_budget: '',
            lifetime_budget: '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Campaign name is required'),
            // objective: Yup.string().required('Objective is required')  
        }),
        onSubmit: (values) => {
            const { name, budget, daily_budget, lifetime_budget, bid_strategy, isAdvantageCampaignEnabled } = values;

            // Common ads account payload
            const adsAccountPayload = {
                id: selectedCampaign?.account_id,
            };

            let payload = {
                name,
                adsAccount: adsAccountPayload
            };

            if (!isAdvantageCampaignEnabled) {
                // CASE 1: Not using Advantage Campaign
                const adset_budgets = [];

                if (Array.isArray(selectedCampaign?.adsets?.data)) {
                    selectedCampaign.adsets.data.forEach((adset) => {
                        const adsetId = adset?.id;
                        const budgetValue = selectedCampaign?.daily_budget || selectedCampaign?.lifetime_budget;
                        const isDailyBudget = !!selectedCampaign?.daily_budget;

                        if (adsetId && budgetValue) {
                            adset_budgets.push({
                                adset_id: adsetId,
                                [isDailyBudget ? 'daily_budget' : 'lifetime_budget']: Number(budgetValue)
                            });
                        }

                    });
                }

                if (bid_strategy && selectedCampaign?.bid_strategy) {
                    payload.bid_strategy = bid_strategy;
                }

                if (adset_budgets.length > 0) {
                    payload.adset_budgets = adset_budgets;
                }

            } else {
                // CASE 2: Advantage Campaign Flow
                if (budget === 'lifetime_budget') {
                    payload.lifetime_budget = Number(lifetime_budget) * 100;
                    payload.currency = currencyCode;
                }

                if (budget === 'daily_budget') {
                    payload.daily_budget = Number(daily_budget) * 100;
                    payload.currency = currencyCode;
                }

                // Only add bid_strategy & adset_bid_amounts if it changed
                if (bid_strategy && bid_strategy !== selectedCampaign?.bid_strategy) {
                    payload.bid_strategy = bid_strategy;

                    // Only set adset_bid_amounts if bid_strategy is NOT "LOWEST_COST_WITHOUT_CAP"
                    if (bid_strategy !== "LOWEST_COST_WITHOUT_CAP") {
                        payload.adset_bid_amounts = {};

                        Object.entries(adsetBidAmounts).forEach(([adSetId, value]) => {
                            payload.adset_bid_amounts[adSetId] = value * 100;
                        });
                    }
                }
            }

            const entriesPayload = {
                campaign: {
                    name,
                    campaign_id: selectedCampaign.campaign_id,
                },
                adsAccount: {
                    adsAccountId: selectedCampaign?.account_id,
                    adsAccountName: selectedCampaign?.account_name,
                }

            }

            updateEntriesCampaign({
                payload: entriesPayload
            }).unwrap()
                .then(() => {
                })

            updateCampaign({
                campaignId: selectedCampaign?.campaign_id,
                payload
            }).unwrap()
                .then(() => {
                    refetchAllCampaignsIds();
                    refetchAllCampaignsList();
                    dispatch(setCampaignDataLoading(true));
                    // refetchCampaignsInsights();
                    toast({
                        position: "top-right",
                        title: "Campaign updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                    onClose();
                })
                .catch((error) => {
                    toast({
                        position: "top-right",
                        title: "Error updating campaign",
                        status: "error",
                        description: error?.data?.message,
                        duration: 4000,
                        isClosable: true,
                    });
                    console.error('Error updating campaign:', error);
                });
        }
    })

    const handleBudgetChange = (e) => {
        const selectedBudgetType = e.target.value;
        if (selectedBudgetType === 'daily_budget') {
            formik.setFieldValue('lifetime_budget', null);
            formik.setFieldValue('daily_budget', Number(formik.values.daily_budget));
        } else if (selectedBudgetType === 'lifetime_budget') {
            formik.setFieldValue('daily_budget', null);
            formik.setFieldValue('lifetime_budget', Number(formik.values.lifetime_budget));
        }
        formik.setFieldValue('budget', selectedBudgetType);
    };

    const handleSwitchChange = (campaign, currentState) => {
        const newStatus = currentState === 'ACTIVE' ? 'PAUSED' : 'ACTIVE';

        // update the switch state
        setSwitchStates(prev => ({ ...prev, [campaign?.campaign_id]: newStatus }));
        updateCampaignStatus({
            campaignId: campaign?.campaign_id,
            payload: {
                status: newStatus,
                adsAccount: {
                    adsAccountId: campaign?.account_id,
                },
            }
        }).unwrap()
            .then(() => {
                if (isMounted.current) {
                    refetchAllCampaignsIds();
                    refetchAllCampaignsList();
                    toast({
                        position: "top-right",
                        title: `Campaign ${newStatus === 'ACTIVE' ? 'activated' : 'paused'}`,
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                }
            })
            .catch((error) => {
                if (isMounted.current) {
                    toast({
                        position: "top-right",
                        title: "Error updating campaign status",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                }
                console.error('Error updating campaign status:', error);

                // Revert switch state if API call fails
                setSwitchStates(prev => ({ ...prev, [campaign?.campaign_id]: currentState }));
            });
    };

    const handleDeleteCampaign = (campaignData) => {

        deleteCampaign({ campaignId: campaignData?.campaign_id, adsAccountId: campaignData?.account_id, })
            .unwrap()
            .then(response => {
                if (allCampaignsIds?.data?.length) {
                    refetchAllCampaignsIds();
                }
                if (allCampaignsList?.length) {
                    refetchAllCampaignsList();
                }
                toast({
                    position: "top-right",
                    title: "Campaign deleted",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch(error => {
                toast({
                    position: "top-right",
                    title: "Error deleting campaign",
                    status: "error",
                    description: error?.data?.message,
                    duration: 4000,
                    isClosable: true,
                });
            });
    };

    const handleDuplicateCampaign = () => {

        duplicateCampaign({ campaignId: selectedCampaign?.campaign_id, payload: { copy_count: copyCount } })
            .unwrap()
            .then(response => {
                refetchAllCampaignsIds();
                refetchCampaignsInsights();
                toast({
                    position: "top-right",
                    title: "Campaign duplicated sucessfully",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch(error => {
                toast({
                    position: "top-right",
                    title: "Error duplicating campaign",
                    status: "error",
                    // description: error?.data?.message,
                    duration: 4000,
                    isClosable: true,
                });
            })
            .finally(() => {
                setSelectedCampaign(null);
                onDuplicateModalClose();
            });
    };

    const handlePageChange = (currentPage) => {
        dispatch(setPresentPage(currentPage));
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set('pageId', presentPage);

        navigate({ search: params.toString() }, { replace: true });

    }, [presentPage]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const storedPage = params.get('pageId');

        if (storedPage && !isNaN(storedPage)) {
            const parsedPage = parseInt(storedPage, 10);
            if (parsedPage >= 1 && parsedPage !== presentPage) {
                dispatch(setPresentPage(parsedPage));
            }
        } else if (presentPage !== 1) {
            dispatch(setPresentPage(1));
        }
    }, [location.search]);

    const columns = useMemo(
        () => [
            {
                Header: "Off/On",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {

                    const isActive = switchStates[original.campaign_id] ?? (original.status === 'ACTIVE');
                    const tooltipText = isActive ? 'Campaign is ON' : 'Campaign is OFF';

                    return (
                        <Flex alignItems={'center'} justifyContent={'center'}>
                            <Tooltip label={tooltipText} fontSize='xs' >
                                <FormControl width={'fit-content'}>
                                    <Switch
                                        colorScheme='brand'
                                        size={'sm'}
                                        isChecked={original.status === 'ACTIVE'}
                                        onChange={() => handleSwitchChange(original.campaign_id, original.status)}
                                        isDisabled={userInfo?.role !== 'client'}
                                    />
                                </FormControl>
                            </Tooltip>
                        </Flex>
                    )
                },
            },
            {
                Header: "Name",
                accessor: "name",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {
                    const isSelected = selectedCampaignId?.campaign_id ? selectedCampaignId?.campaign_id : selectedCampaignId === original?.campaign_id;

                    return (
                        <Box>
                            <Box>
                                <Flex alignItems={'flex-start'}>
                                    <Link
                                        to={'#'}
                                        onClick={() => {
                                            setSelectedTab(1);
                                            dispatch(setSelectedCampaignId(original));
                                        }}
                                    >
                                        <Text
                                            _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
                                            fontWeight={isSelected ? 'bold' : 'normal'}
                                            color={isSelected ? 'brand.500' : 'inherit'}
                                            fontSize={'14px'}
                                        >
                                            {original.name.length > 30 ? `${original.name.slice(0, 30)}...` : original.name}
                                        </Text>
                                    </Link>
                                </Flex>
                            </Box>
                            <Box display={'flex'} dir='row' gap={2}>
                                <Flex
                                    alignItems={'center'}
                                    gap={0.5}
                                    onClick={() => {
                                        if (userInfo?.role === 'client') {
                                            setSelectedCampaign(original);
                                            onOpen();
                                        }
                                    }}>
                                    <Icon
                                        as={MdEdit}
                                        cursor={userInfo?.role === 'client' ? "pointer" : "not-allowed"}
                                        color={userInfo?.role === 'client' ? "inherit" : "gray.300"}
                                        fontSize={'12px'}
                                    />
                                    <Link
                                        to={'#'}
                                    >
                                        <Text
                                            _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
                                            fontWeight={'normal'}
                                            color={'inherit'}
                                            fontSize={'11px'}
                                        >
                                            Edit
                                        </Text>
                                    </Link>
                                </Flex>
                                <Flex
                                    alignItems={'center'}
                                    gap={0.5}
                                    onClick={() => {
                                        if (userInfo?.role === 'client') {
                                            setSelectedCampaign(original);
                                            onDuplicateModalOpen();
                                        }
                                    }}
                                >
                                    <Icon
                                        as={HiOutlineDocumentDuplicate}
                                        cursor={userInfo?.role === 'client' ? "pointer" : "not-allowed"}
                                        color={userInfo?.role === 'client' ? "inherit" : "gray.300"}
                                        fontSize={'12px'}
                                    />
                                    <Link
                                        to={'#'}
                                    >
                                        <Text
                                            _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
                                            fontWeight={'normal'}
                                            color={'inherit'}
                                            fontSize={'11px'}
                                        >
                                            Duplicate
                                        </Text>
                                    </Link>
                                </Flex>
                            </Box>
                        </Box>
                    )
                },
            },
            {
                Header: "Delivery",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {


                    const getStatusMessage = (status) => {
                        switch (status) {
                            case 'WITH_ISSUES':
                                return 'Delivery error';
                            case 'CAMPAIGN_PAUSED':
                                return 'Campaign Off';
                            case 'ADSET_PAUSED':
                                return 'Adset Off';
                            case 'PAUSED':
                                return 'Off';
                            default:
                                return status || 'Unknown';
                        }
                    };

                    const errorMessage = original?.issues_info?.[0]?.error_message || '';

                    // Function to determine circle color and border based on status
                    const getCircleStyles = (status) => {
                        switch (status) {
                            case 'WITH_ISSUES':
                                return { bg: 'rgb(161,11,24)', border: 'none' };  // Red for delivery error
                            case 'CAMPAIGN_PAUSED':
                            case 'ADSET_PAUSED':
                                return { bg: 'rgb(216,221,225)', border: 'none' };  // Gray for Campaign/Adset Off
                            case 'ACTIVE':
                                return { bg: 'rgb(255,255,255)', border: '2px solid green' };  // Gray background with green border for ACTIVE
                            case 'IN_PROCESS':
                            case 'PENDING_REVIEW':
                                return { bg: 'rgb(255,255,255)', border: '2px solid green' };
                            default:
                                return { bg: 'rgb(255,255,255)', border: 'none' };  // Default gray with no border
                        }
                    };

                    const circleStyles = getCircleStyles(original?.effective_status);

                    const formatTooltipMessage = (message) => {
                        return message.split('\n').map((part, index) => (
                            <span key={index}>
                                {part}
                                <br />
                            </span>
                        ));
                    };

                    // Determine tooltip message
                    const getTooltipMessage = (status) => {
                        switch (status) {
                            case 'WITH_ISSUES':
                                return errorMessage;
                            case 'PAUSED':
                                return 'This campaign is turned off';
                            case 'ACTIVE':
                                return 'This campaign is on and running normally.';
                            case 'ADSET_PAUSED':
                                return 'This ad is on, but its ad set is turned off.';
                            case 'IN_PROCESS':
                                return 'Your ad is processing.\nMeta is processing your recent updates to your ad. Some updates may take several hours.';
                            default:
                                return '';  // No tooltip for other statuses
                        }
                    };

                    const tooltipMessage = getTooltipMessage(original?.effective_status);

                    return (
                        <Flex>
                            {/* Only show Tooltip when status is WITH_ISSUES */}
                            {original?.effective_status === 'WITH_ISSUES' ? (
                                <Flex alignItems={'center'}>
                                    <Box
                                        bg={circleStyles.bg}
                                        border={circleStyles.border}
                                        borderRadius="50%"
                                        boxSize="0.8rem"
                                        display="inline-block"
                                        mr={2}
                                    />
                                    <Tooltip label={formatTooltipMessage(tooltipMessage)} aria-label="Error message" hasArrow p={2} fontSize={'12px'}>
                                        <Text fontSize={'14px'}>{getStatusMessage(original?.effective_status)}</Text>
                                    </Tooltip>
                                </Flex>
                            ) : (
                                <Flex alignItems={'center'}>
                                    {(original?.effective_status === 'PAUSED' || original?.effective_status === 'DELETED') ? (null) : (
                                        <Box
                                            bg={circleStyles.bg}
                                            border={circleStyles.border}
                                            borderRadius="50%"
                                            boxSize="0.8rem"
                                            display="inline-block"
                                            mr={2}
                                        />
                                    )}
                                    {/* Skip Tooltip for PENDING_REVIEW */}
                                    {original?.effective_status !== 'PENDING_REVIEW' && (
                                        <Tooltip label={formatTooltipMessage(tooltipMessage)} aria-label="Error message" hasArrow p={2} fontSize={'12px'}>
                                            <Text fontSize={'14px'}>{getStatusMessage(original?.effective_status)}</Text>
                                        </Tooltip>
                                    )}
                                    {original?.effective_status === 'PENDING_REVIEW' && (
                                        <Text fontSize={'14px'}>{getStatusMessage(original?.effective_status)}</Text>
                                    )}
                                </Flex>
                            )}
                        </Flex>
                    )
                }
            },
            {
                Header: "Spend",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>
                            {original?.insight?.spend ? `${currencySymbol}${Number(original.insight.spend).toFixed(2)}` : '-'}
                        </Text>
                    </Flex>
                )
            },
            {
                Header: "Results",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {
                  const { insight, adsets = [] } = original;
                  const safeAdsets = Array.isArray(adsets?.data) ? adsets.data : [];
              
                  // Mapping for derived event names
                  const eventNameMap = {
                    destination_type: {
                      ON_AD: "Meta Leads",
                      App: "In-app subscribes",
                    },
                    optimization_goal: {
                      APP_INSTALLS: "Mobile App Installation",
                      LEAD_GENERATION: "Leads",
                      THRUPLAY: "Thruplay",
                      LINK_CLICKS: "Link Clicks",
                      PAGE_LIKES: "Follows or Likes",
                      QUALITY_CALL: "20-second Call",
                      REACH: 'Reach',
                      IMPRESSIONS: 'Reach'
                    },
                  };
              
                  // Derive event name from adsets
                  let derivedEventName = null;
                  for (const adset of safeAdsets) {
                    if (eventNameMap.destination_type[adset.destination_type]) {
                      derivedEventName = eventNameMap.destination_type[adset.destination_type];
                      break;
                    }
                    if (eventNameMap.optimization_goal[adset.optimization_goal]) {
                      derivedEventName = eventNameMap.optimization_goal[adset.optimization_goal];
                      break;
                    }
                  }
              
                  // Format original eventName
                  const originalEventName = insight?.eventName
                    ? insight.eventName.charAt(0).toUpperCase() + insight.eventName.slice(1)
                    : null;
              
                  return (
                    <Flex direction="column" mb={-4}>
                      <Text fontSize="14px">
                        {insight?.results ? insight.results : "-"}
                      </Text>
                      {(derivedEventName || originalEventName) && (
                        <Text fontSize="10px" color="gray.500">
                          {derivedEventName || originalEventName}
                        </Text>
                      )}
                    </Flex>
                  );
                },
            },  
            {
                Header: "CPC",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>{original.insight?.cpc ? `${currencySymbol}${Number(original.insight?.cpc).toFixed(2)}` : '-'}</Text>
                    </Flex>
                )
            },
            {
                Header: "CTR",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex>
                        <Text fontSize={'14px'}>
                            {original.insight?.ctr ? `${Number(original.insight?.ctr).toFixed(2)}%` : '-'}
                        </Text>
                    </Flex>
                )
            },
            {
                Header: "CPM",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>{original.insight?.cpm ? Number(original.insight?.cpm).toFixed(2) : '-'}</Text>
                    </Flex>
                )
            },
            {
                Header: "Clicks",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>{original.insight?.clicks ? original.insight?.clicks : '-'}</Text>
                    </Flex>
                )
            },
            {
                Header: "Purchase Value",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>
                            {original.insight?.purchaseValue && original.insight.purchaseValue !== '-' ?
                                `${currencySymbol}${parseFloat(original.insight.purchaseValue).toFixed(2)}` :
                                original.insight?.purchaseValue || '-'}
                        </Text>
                    </Flex>
                )
            },
            {
                Header: "Roas",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {
                    const roas = original.insight?.roas;

                    // Check if roas is a valid number or a non-numeric value like '-'
                    const formattedROAS = (roas && !isNaN(parseFloat(roas)))
                        ? parseFloat(roas).toFixed(2)
                        : '-';  // Default to '-' if roas is invalid or non-numeric

                    return (
                        <Flex>
                            <Text fontSize={'14px'}>
                                {formattedROAS}
                            </Text>
                        </Flex>
                    );
                }
            },
            {
                Header: "hook Rate",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>{original.insight?.hookRate ? `${Number(original.insight?.hookRate).toFixed(2)}%` : '-'}</Text>
                    </Flex>
                )
            },
            {
                Header: "hold Rate",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'}>
                        <Text fontSize={'14px'}>{original.insight?.holdRate ? `${Number(original.insight?.holdRate).toFixed(2)}%` : '-'}</Text>
                    </Flex>
                )
            },
            {
                Header: "Objective",
                accessor: "objective",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {

                    let objective = '';

                    if (original.objective === 'OUTCOME_SALES') {
                        objective = 'Sales';
                    } else if (original.objective === 'OUTCOME_LEADS') {
                        objective = 'Leads';
                    } else if (original.objective === 'OUTCOME_APP_PROMOTION') {
                        objective = 'App promotion';
                    } else if (original.objective === 'OUTCOME_AWARENESS') {
                        objective = 'Awareness';
                    }

                    return <Text fontSize={'14px'}>{objective}</Text>;
                }
            },
            {
                Header: "Status",
                accessor: "status",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => {
                    // console.log(original);

                    let statusCopy = '';
                    if (original.status == 'ARCHIVED') {
                        statusCopy = 'PUBLISHED';
                    } else {
                        statusCopy = original.status;
                    }
                    return (
                        <Text fontSize={'14px'}>{statusCopy}</Text>
                    )
                },
            },
            {
                Header: "Created Date",
                accessor: "createdDate",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Text fontSize={'14px'}>{moment(original.created_time).format("DD-MM-YYYY hh:mm A")}</Text>

                ),
            },
            {
                Header: "Updated Date",
                accessor: "updatedDate",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Text fontSize={'14px'}>{moment(original.updated_time).format("DD-MM-YYYY hh:mm A")}</Text>
                ),
            },
            {
                Header: "Actions",
                accessor: "",
                Filter: "",
                filter: "",
                Cell: ({ row: { original } }) => (
                    <Flex gap={'10px'} alignItems={'center'}>
                        <Tooltip label='Delete' fontSize='xs' >
                            <Flex>
                                <Icon
                                    cursor={userInfo?.role === 'client' ? "pointer" : "not-allowed"}
                                    color={userInfo?.role === 'client' ? "red.500" : "gray.300"}
                                    as={MdDelete}
                                    onClick={() => {
                                        if (userInfo?.role === 'client') {
                                            setSelectedCampaign(original);
                                            setIsConfirmationModalOpen(true);
                                        }
                                    }}
                                />
                            </Flex>
                        </Tooltip>
                    </Flex>
                )
            },
        ],
        [selectedCampaignId]
    );

    const confirmDelete = () => {
        if (selectedCampaign) {
            handleDeleteCampaign(selectedCampaign);
            setIsConfirmationModalOpen(false);
            setSelectedCampaign(null);
        }
    };

    const handleOnSuccess = () => {
        refetchAllCampaignsList();
    }

    const isBudgetChanged = (() => {
        if (!selectedCampaign?.bid_strategy) return false;

        const originalDaily = Number(selectedCampaign.daily_budget) / 100;
        const originalLifetime = Number(selectedCampaign.lifetime_budget) / 100;

        return (
            (formik.values.budget === 'daily_budget' && Number(formik.values.daily_budget) !== originalDaily) ||
            (formik.values.budget === 'lifetime_budget' && Number(formik.values.lifetime_budget) !== originalLifetime) ||
            !selectedCampaign?.adsets?.data?.length > 0
        );
    })();

    return (
        <>
            {/* <Flex mb={2}>
                <Button
                    leftIcon={<AddIcon boxSize={3} />}
                    colorscheme="brand"
                    size="sm"
                    onClick={() => setIsCreateFormVisible(true)}
                >
                    Create
                </Button>
            </Flex>

            {isCreateFormVisible && (
                <CreateCampaignForm
                    adsAccountData={adsAccountData}
                    isOpen={isCreateFormVisible}
                    onClose={() => setIsCreateFormVisible(false)}
                    onSuccess={handleOnSuccess}
                />
            )} */}

            <DeleteConfirmationModal
                isOpen={isConfirmationModalOpen}
                onClose={() => setIsConfirmationModalOpen(false)}
                onConfirm={confirmDelete}
                message="Are you sure you want to delete this Campaign? This action can't be undone."
            />

            {/* DUPLICATE CAMPAIGN MODAL */}
            <Modal
                size={"xl"}
                isCentered={true}
                isOpen={isDuplicateModalOpen}
                scrollBehavior={"inside"}
                onClose={onDuplicateModalClose}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader fontSize={'md'}>Duplicate your campaign</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex gap={1} direction={'column'}>
                            <Text fontSize={'14px'} fontWeight={'bold'}>Number of copies</Text>
                            <NumberInput value={copyCount} onChange={(valueString, valueNumber) => setCopyCount(valueNumber)} min={1} size="sm" width={'530px'}>
                                <NumberInputField />
                                <NumberInputStepper>
                                    <NumberIncrementStepper border={'none'} />
                                    <NumberDecrementStepper border={'none'} />
                                </NumberInputStepper>
                            </NumberInput>
                        </Flex>
                    </ModalBody>
                    <ModalFooter>
                        <Button size={'sm'} mr={3} onClick={onDuplicateModalClose}>
                            Cancel
                        </Button>
                        <Button colorScheme="brand" isLoading={isCampaignDuplicating} size={'sm'} onClick={handleDuplicateCampaign}>
                            Duplicate
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* EDIT CAMPAIGN MODAL */}
            <Modal
                size={"xl"}
                isCentered={true}
                isOpen={isOpen}
                scrollBehavior={"inside"}
                onClose={onClose}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Edit Campaign</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <form onSubmit={formik.handleSubmit}>
                            <Box width="100%" maxWidth="600px" bg={background} p={4} borderRadius="md">
                                <Flex direction="column" gap={4}>
                                    <Box>
                                        <Flex align="center">
                                            <Text mb={2}>
                                                Campaign Name
                                            </Text>
                                        </Flex>
                                        <Input
                                            placeholder="Enter campaign name"
                                            bg="#fff"
                                            name="name"
                                            size={'sm'}
                                            borderRadius="md"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.touched.name && formik.errors.name && (
                                            <Text fontSize={'12px'} color="red.500" mt={1}>{formik.errors.name}</Text>
                                        )}
                                    </Box>

                                    <Box>
                                        <Flex align="center">
                                            <Text mb={2}>
                                                Objective
                                            </Text>
                                        </Flex>
                                        <Select
                                            name="type"
                                            borderRadius="md"
                                            value={formik.values.objective}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            size="sm"
                                            isDisabled
                                        >
                                        <option value="OUTCOME_LEAD">Leads</option>
                                        <option value="OUTCOME_SALES">Sales</option>
                                        <option value="OUTCOME_AWARENESS">Awareness</option>
                                        <option value="OUTCOME_APP_PROMOTION">App promotion</option>
                                        </Select>
                                    </Box>

                                    {/* Advantage campaign section */}
                                    {selectedCampaign?.smart_promotion_type === 'AUTOMATED_SHOPPING_ADS' ? null :
                                        <Box>
                                            <Flex alignItems={'center'} justifyContent={'space-between'} mb={2}>
                                                <Box display={'flex'} alignItems={'center'} gap={1}>
                                                    <Text fontWeight="bold">Advantage campaign budget</Text>
                                                    <GiStarShuriken />
                                                </Box>

                                                <Box display={'flex'} alignItems={'center'} gap={2}>
                                                    <Text>{formik.values.isAdvantageCampaignEnabled ? 'On' : 'Off'}</Text>

                                                    <Tooltip
                                                        borderRadius={5}
                                                        placement="right"
                                                        isDisabled={!!(selectedCampaign?.adsets?.data?.length > 0)}
                                                        label={
                                                            <Box fontSize="sm" p="5px">
                                                                <Text>
                                                                    To turn off Advantage campaign budget, you must create an ad set in this campaign.
                                                                </Text>
                                                            </Box>
                                                        }
                                                        fontSize="md"
                                                        hasArrow
                                                    >
                                                        <Box display="inline-block">
                                                            <Switch
                                                                colorScheme="brand"
                                                                isDisabled={!selectedCampaign?.adsets?.data?.length}
                                                                isChecked={formik.values.isAdvantageCampaignEnabled}
                                                                onChange={() =>
                                                                    formik.setFieldValue(
                                                                        'isAdvantageCampaignEnabled',
                                                                        !formik.values.isAdvantageCampaignEnabled
                                                                    )
                                                                }
                                                            />
                                                        </Box>
                                                    </Tooltip>
                                                </Box>
                                            </Flex>
                                            <Text fontSize={'12px'} textAlign={'justify'}>Distribute your budget across ad sets to get more results. You can control spending for each ad set.</Text>
                                        </Box>
                                    }

                                    {formik.values.isAdvantageCampaignEnabled ? (
                                        <>
                                            <Flex my={2} direction={'column'} gap={2}>
                                                {/* Budget */}
                                                <Flex alignItems={'center'}>
                                                    <Text fontWeight="bold">Budget</Text>
                                                    <Tooltip
                                                        borderRadius={5}
                                                        label={
                                                            <Box fontSize="sm" p={'5px'}>
                                                                <Text >
                                                                    If you choose a daily budget, you may spend more on some days and less on others but will maintain an average daily budget. If you choose a lifetime budget, we'll never spend more than that amount.
                                                                </Text>
                                                            </Box>
                                                        }
                                                        fontSize="md"
                                                    >
                                                        <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                    </Tooltip>
                                                </Flex>
                                                <Flex gap={1}>
                                                    <Select
                                                        name="budget"
                                                        value={formik.values.budget}
                                                        onChange={handleBudgetChange}
                                                        onBlur={formik.handleBlur}
                                                        bg="#fff"
                                                        borderRadius={'md'}
                                                        maxW={'200px'}
                                                        size={'sm'}
                                                        isDisabled={selectedCampaign?.bid_strategy}
                                                    >
                                                        {budgetOptions?.map((option) => (
                                                            <option key={option.value} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                    {formik.values.budget === 'daily_budget' ? (
                                                        <InputGroup>
                                                            <Input
                                                                name="daily_budget"
                                                                placeholder={currencySymbol}
                                                                bg="#fff"
                                                                type="number"
                                                                value={String(formik.values.daily_budget)}
                                                                onChange={(e) => formik.setFieldValue('daily_budget', e.target.value)}
                                                                onBlur={formik.handleBlur}
                                                                borderRadius={'md'}
                                                                size={'sm'}
                                                            />
                                                            <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                                {currencyCode}
                                                            </InputRightAddon>
                                                        </InputGroup>
                                                    ) : null}
                                                    {formik.values.budget === 'lifetime_budget' ? (
                                                        <InputGroup>
                                                            <Input
                                                                name="lifetime_budget"
                                                                placeholder={currencySymbol}
                                                                bg="#fff"
                                                                type="number"
                                                                value={String(formik.values.lifetime_budget)}
                                                                onChange={(e) => formik.setFieldValue('lifetime_budget', e.target.value)}
                                                                onBlur={formik.handleBlur}
                                                                borderRadius={'md'}
                                                                size={'sm'}
                                                            />
                                                            <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                                {currencyCode}
                                                            </InputRightAddon>
                                                        </InputGroup>
                                                    ) : null}
                                                </Flex>
                                                <Box display={'flex'} flexDirection='column' gap='2'>
                                                    <Flex alignItems={'center'}>
                                                        <Text fontWeight="bold">Campaign bid strategy</Text>
                                                        <Tooltip
                                                            borderRadius={5}
                                                            label={
                                                                <Box fontSize="sm" p={'5px'}>
                                                                    <Text >
                                                                        Cost per result goal, ROAS goal or bid caps allow you to enter a specific amount later for each ad set.
                                                                    </Text>
                                                                </Box>
                                                            }
                                                            fontSize="md"
                                                        >
                                                            <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                        </Tooltip>
                                                    </Flex>

                                                    <Flex>
                                                        <Text fontSize={'12px'}>How we'll bid in ad auctions.</Text>
                                                    </Flex>

                                                    <Flex>
                                                        <Menu>
                                                            <MenuButton
                                                                as={Button}
                                                                borderRadius="md"
                                                                p={2}
                                                                bg={isBudgetChanged ? 'gray.50' : '#fff'}
                                                                cursor={isBudgetChanged ? "not-allowed" : "pointer"}
                                                                _hover={{ bg: isBudgetChanged ? 'gray.50' : '#fff' }}
                                                                w='auto'
                                                                fontSize='12px'
                                                            >
                                                                <Flex alignItems={'center'} justifyContent="space-between" gap='2'>
                                                                    <Text color={isBudgetChanged ? 'gray.500' : 'none'}>
                                                                        {formik.values.bid_strategy
                                                                            ? (formik.values.objective === 'OUTCOME_SALES'
                                                                                ? bidStrategiesForSales.find(option => option.value === formik.values.bid_strategy)?.label
                                                                                : formik.values.objective === 'OUTCOME_LEADS'
                                                                                ? bidStrategiesForLeads.find(option => option.value === formik.values.bid_strategy)?.label
                                                                                : formik.values.objective === 'OUTCOME_APP_PROMOTION'
                                                                                ? bidStrategiesForLeads.find(option => option.value === formik.values.bid_strategy)?.label 
                                                                                : formik.values.objective === 'OUTCOME_AWARENESS'
                                                                                ? bidStrategiesForLeads.find(option => option.value === formik.values.bid_strategy)?.label 
                                                                                : "Select a bid strategy")
                                                                            : "Select a bid strategy"}
                                                                    </Text>
                                                                    <ChevronDownIcon boxSize='5' />
                                                                </Flex>
                                                            </MenuButton>

                                                            {isBudgetChanged ? null : (
                                                                <MenuList zIndex={20}>
                                                                    {(formik.values.objective === 'OUTCOME_SALES' ? bidStrategiesForSales : bidStrategiesForLeads).map((option) => {
                                                                        const isBidCap = option?.value === 'LOWEST_COST_WITH_BID_CAP';
                                                                        const isCostCap = option?.value === 'COST_CAP';
                                                                        const isQualityLead = selectedCampaign && selectedCampaign?.adsets?.data[0]?.optimization_goal === 'QUALITY_LEAD';

                                                                        // Skip rendering COST_CAP if optimization_goal is QUALITY_LEAD
                                                                        if (isCostCap && isQualityLead) {
                                                                            return null;
                                                                        }

                                                                        const MenuItemContent = (
                                                                            <Box
                                                                                display="flex"
                                                                                justifyContent="space-between"
                                                                                width="100%"
                                                                                alignItems="center"
                                                                                py={2}
                                                                                px={2}
                                                                            >
                                                                                <Box>
                                                                                    <Text fontWeight="medium" fontSize="12px">{option.label}</Text>
                                                                                    <Text fontSize="12px">{option.description}</Text>
                                                                                </Box>
                                                                                {isBidCap && selectedCampaign?.bid_strategy !== 'LOWEST_COST_WITH_BID_CAP' && (
                                                                                    <ChevronRightIcon boxSize='5' />
                                                                                )}
                                                                            </Box>
                                                                        );

                                                                        return (isBidCap && selectedCampaign?.bid_strategy !== 'LOWEST_COST_WITH_BID_CAP') ? (
                                                                            <Popover trigger="hover" placement="right-start" closeOnBlur={false} key={option.value}>
                                                                                <PopoverTrigger>
                                                                                    <Box width="100%">
                                                                                        <MenuItem
                                                                                            _hover={{ bg: 'gray.50' }}
                                                                                            p={0}
                                                                                        >
                                                                                            {MenuItemContent}
                                                                                        </MenuItem>
                                                                                    </Box>
                                                                                </PopoverTrigger>
                                                                                <PopoverContent
                                                                                    cursor='pointer'
                                                                                    width="auto"
                                                                                    onMouseEnter={(e) => e.stopPropagation()}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        formik.setFieldValue('bid_strategy', option.value);
                                                                                        onBidModalOpen();
                                                                                    }}
                                                                                >
                                                                                    <PopoverArrow />
                                                                                    <PopoverBody>
                                                                                        <Text fontWeight="semibold" fontSize='14px'>Bid cap</Text>
                                                                                        <Text fontSize="12px">
                                                                                            Set the highest that you want to bid in any auction.
                                                                                        </Text>
                                                                                    </PopoverBody>
                                                                                </PopoverContent>
                                                                            </Popover>
                                                                        ) : (
                                                                            <MenuItem
                                                                                key={option.value}
                                                                                onClick={() => {
                                                                                    formik.setFieldValue('bid_strategy', option.value);
                                                                                    if (
                                                                                        selectedCampaign?.bid_strategy === 'LOWEST_COST_WITHOUT_CAP' &&
                                                                                        option.value === 'LOWEST_COST_WITHOUT_CAP'
                                                                                    ) {
                                                                                        return;
                                                                                    } else if (selectedCampaign?.bid_strategy !== option.value && option.value !== 'LOWEST_COST_WITHOUT_CAP') {
                                                                                        onBidModalOpen();
                                                                                    }
                                                                                }}
                                                                                _hover={{ bg: 'gray.50' }}
                                                                                py={2}
                                                                                flexDirection="column"
                                                                                alignItems="flex-start"
                                                                            >
                                                                                <Text fontWeight="medium" fontSize="12px">{option.label}</Text>
                                                                                <Text fontSize="12px">{option.description}</Text>
                                                                            </MenuItem>
                                                                        );
                                                                    })}
                                                                </MenuList>
                                                            )}
                                                        </Menu>
                                                    </Flex>

                                                    <Flex alignItems={'center'}>
                                                        <Text fontSize={'10px'}>Not all bid strategies are available for all campaigns.</Text>
                                                        <Tooltip
                                                            borderRadius={5}
                                                            label={
                                                                <Box fontSize="12px" p={'5px'}>
                                                                    <Text >
                                                                        The highest-volume bid strategy is only available if all ad sets are using the same delivery optimisation.<br></br>
                                                                        Cost per result goal is only available for some delivery optimisations.
                                                                    </Text>
                                                                </Box>
                                                            }
                                                            fontSize="md"
                                                        >
                                                            <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                        </Tooltip>
                                                    </Flex>
                                                </Box>
                                            </Flex>

                                            <Divider />

                                            <Flex direction='column' gap={1}>
                                                <Flex alignItems={'center'}>
                                                    <Text fontWeight="bold">Ad scheduling</Text>
                                                    <Tooltip
                                                        borderRadius={5}
                                                        label={
                                                            <Box fontSize="sm" p={'5px'}>
                                                                <Text >
                                                                    You can schedule your ads to deliver on specific hours and days of the week based on the viewer's or your ad account's time zone.
                                                                </Text>
                                                            </Box>
                                                        }
                                                        fontSize="md"
                                                    >
                                                        <InfoOutlineIcon pointerEvents="all" ml={2} />
                                                    </Tooltip>
                                                </Flex>
                                                <Text fontSize='12px'>You'll set the specific schedule within each ad set.</Text>
                                                <Flex>
                                                    <Checkbox
                                                        size={'md'}
                                                        colorScheme='brand'
                                                        isChecked={formik.values.isAdScheduled}
                                                        onChange={() => formik.setFieldValue('isAdScheduled', !formik.values.isAdScheduled)}
                                                        isDisabled
                                                    >
                                                        <Flex direction='column'>
                                                            <Text fontSize='12px'>Run ads on a schedule</Text>
                                                            {formik.values.budget !== 'lifetime_budget' ?
                                                                <Text fontSize='10px'>Ad scheduling is only available when you use lifetime budget.</Text>
                                                                : null}
                                                        </Flex>
                                                    </Checkbox>
                                                </Flex>
                                            </Flex>
                                        </>
                                    ) : (null)}
                                </Flex>
                            </Box>

                            {/* Submit Button in a separate Flex container */}
                            <Flex mt={4}>
                                <Button
                                    colorScheme="brand"
                                    isLoading={isCampaignUpdating}
                                    isDisabled={!formik.isValid}
                                    type="submit"
                                    size={'sm'}
                                    mb={'10px'}
                                >
                                    Save
                                </Button>
                            </Flex>
                        </form>
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isBidModalOpen} onClose={onBidModalClose} scrollBehavior="inside" isCentered size="2xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader p={2} fontSize="md">Set bid caps for 3 ad sets</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody borderTop="1px" borderColor="gray.100">
                        <Text fontSize="12px" mb={4}>
                            Set bid caps for all of the ad sets (published and inactive) in this campaign.
                        </Text>

                        <Box border="1px" borderColor="gray.200" borderRadius="md" overflow="hidden">
                            <Table size="sm" variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th fontSize="12px">Ad set name</Th>
                                        <Th fontSize="12px">Status</Th>
                                        <Th fontSize="12px">{formik.values.bid_strategy === 'LOWEST_COST_WITH_BID_CAP' ? 'Bid cap' : formik.values.bid_strategy === 'COST_CAP' ? 'Cost per result goal' : 'ROAS goal'}</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {selectedCampaign?.adsets?.data?.map((adSet, id) => (
                                        <Tr key={id}>
                                            <Td fontSize="12px">{adSet.name}</Td>
                                            <Td fontSize="12px" borderRight={'2px'} borderRightColor={'green.500'}>{adSet.status}</Td>
                                            <Td fontSize="12px">
                                                <Input
                                                    placeholder={currencySymbol}
                                                    size="sm"
                                                    width="80px"
                                                    value={adsetBidAmounts[adSet?.id]}
                                                    type="number"
                                                    onChange={(e) => {
                                                        const newValue = parseFloat(e.target.value);
                                                        setAdsetBidAmounts(prev => ({
                                                            ...prev,
                                                            [adSet.id]: newValue,
                                                        }));
                                                    }}
                                                />
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>

                        <Box pt={8}>
                            <Flex gap={4}>
                                <Flex>
                                    <Text fontWeight="bold">Campaign budget</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text>
                                                    {selectedCampaign?.daily_budget ? 'With a daily budget, we may spend more on some days and less on others, but will maintain an average daily budget.' : 'With a lifetime budget, we may spend more on some days and less on others, but will maintain an average lifetime budget.'}
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" m={1} />
                                    </Tooltip>
                                </Flex>
                                <Flex w={'120px'} direction='column' gap={1}>
                                    {formik.values.budget === 'daily_budget' ? (
                                        <InputGroup>
                                            <Input
                                                name="daily_budget"
                                                placeholder={currencySymbol}
                                                bg="#fff"
                                                type="number"
                                                value={String(formik.values.daily_budget)}
                                                onChange={(e) => formik.setFieldValue('daily_budget', e.target.value)}
                                                onBlur={formik.handleBlur}
                                                borderRight={'none'}
                                                size={'sm'}
                                            />
                                            <InputRightAddon height={'32px'} fontSize={'10px'} bg='none' borderRadius={'none'}>
                                                {currencyCode}
                                            </InputRightAddon>
                                        </InputGroup>
                                    ) : null}
                                    {formik.values.budget === 'lifetime_budget' ? (
                                        <InputGroup>
                                            <Input
                                                name="lifetime_budget"
                                                placeholder={currencySymbol}
                                                bg="#fff"
                                                type="number"
                                                value={String(formik.values.lifetime_budget)}
                                                onChange={(e) => formik.setFieldValue('lifetime_budget', e.target.value)}
                                                onBlur={formik.handleBlur}
                                                borderRadius={'md'}
                                                size={'sm'}
                                            />
                                            <InputRightAddon height={'32px'} fontSize={'14px'}>
                                                {currencyCode}
                                            </InputRightAddon>
                                        </InputGroup>
                                    ) : null}
                                    <Flex>
                                        <Text fontSize={'12px'} color='gray' fontWeight='semibold'>{formik.values.budget === 'daily_budget' ? 'daily budget' : 'lifetime budget'}</Text>
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Box>
                    </ModalBody>

                    <ModalFooter>
                        <Flex borderTop="1px" borderColor="gray.100" pt={2} justifyContent="space-between" w="100%">
                            <Button onClick={onBidModalClose} size="sm">
                                Close
                            </Button>
                            <Button
                                onClick={() => {
                                    formik.handleSubmit();
                                    onBidModalClose();
                                    onClose();
                                }}
                                size="sm"
                                colorScheme="brand"
                            >
                                Save
                            </Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {AllcampaignslistError || campaignsInsightsError ? (
                <Flex justifyContent={'center'} alignItems={'center'} height={'50vh'}>
                    <Text color="red.500">
                        {/* {"Sorry, Campaigns not available at this moment. Try again later."} */}
                        {AllcampaignslistError?.data?.message}
                    </Text>
                </Flex>
            ) : (isAllCampaignListLoading || isCampaignInsightsLoading || isLoadingCampaignsListWithInsights || onRefresh) ? (
                <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'50vh'}>
                    <Spinner />
                    <Text>Loading…</Text>
                </Flex>
            ) : (
                <AppTableWithPagination
                    columns={columns}
                    data={campaignsListWithInsights || []}
                    paginationMeta={allCampaignsIds?.meta || {}}
                    onPageChange={handlePageChange}
                    onSearchInputChange={(searchInput) => setsearchValue(searchInput)}
                    searchEnabled={true}
                    isFetching={isAllCampaignIdsFetching}
                />
            )}
        </>
    );
}

export default AllCampaignsTable;

